<label>{{ item?.label || "select_a_field" | translation }}</label>

<p-select
  ngDefaultControl
  [placeholder]="'Field' | translation"
  [options]="options"
  [(ngModel)]="selectedKey"
  optionLabel="name"
  optionValue="name"
  (onChange)="updateValue()"
/>
